import { render, staticRenderFns } from "./SongDetail.vue?vue&type=template&id=1726f6ec&scoped=true&"
import script from "./SongDetail.vue?vue&type=script&lang=ts&"
export * from "./SongDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SongDetail.vue?vue&type=style&index=0&id=1726f6ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1726f6ec",
  null
  
)

export default component.exports